import Bluebird from 'bluebird'
import transitionPath from 'router5-transition-path'
import { findRoutes }  from '../utils'

import {
  MiddlewareFactory,
  RouteTriggerHandler,
  AppRoute,
} from '../../types/router'

import {
  RootState,
} from '../../types/store'

/*

  trigger actions when routes become active

*/
function TriggerMiddlewareFactory() {
  const triggerRoute: MiddlewareFactory = (routes) => (router, dependencies) => async (toState, fromState, done) => {
    const {
      toActivate,
      toDeactivate,
    } = transitionPath(toState, fromState)
    const { store } = dependencies

    const deactiveRoutes = findRoutes(routes as AppRoute[], toDeactivate)
    const activeRoutes = findRoutes(routes as AppRoute[], toActivate)
    
    const deactiveTriggers = deactiveRoutes.reduce<RouteTriggerHandler[]>((all, route) => {
      return all.concat(route.onLeave || [])
    }, [])

    const activeTriggers = activeRoutes.reduce<RouteTriggerHandler[]>((all, route) => {
      return all.concat(route.onEnter || [])
    }, [])

    await Bluebird.each(deactiveTriggers, async trigger => {
      await trigger(store, fromState.params)
    })

    await Bluebird.each(activeTriggers, async trigger => {
      await trigger(store, toState.params)
    })
  }
  return triggerRoute
}

export default TriggerMiddlewareFactory